var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "program-list"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('v-row', {
      attrs: {
        "justify": "center",
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', {
      class: {
        'order-lg-2': (index + 1) % 2 === 0
      },
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-center"
    }, [_c('v-card', {
      staticClass: "program-list__card",
      attrs: {
        "color": "primary",
        "max-width": "560"
      }
    }, [_c('v-img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })], 1)], 1)]), _c('v-col', {
      attrs: {
        "cols": "auto",
        "lg": "6"
      }
    }, [_c('div', {
      staticClass: "pa-20 pa-lg-40"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('h4', {
      staticClass: "tit tit--sm primary--text"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, _vm._l(item.texts, function (text) {
      return _c('v-row', {
        key: text,
        staticClass: "row--sm page-text page-text--lg"
      }, [_c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_vm._v("·")]), _c('v-col', [_c('p', {
        domProps: {
          "innerHTML": _vm._s(text)
        }
      })])], 1);
    }), 1)], 1)], 1)])], 1)], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }